<template>
  <div class="file-drop-zone">
    <widget-icon
      name="tmi-cloud-upload"
      size="48px"
      class="light--text"
    />
    <div
      v-if="text"
      class="subhead-semi-bold-14 strong--text"
    >
      {{ text }}
    </div>
    <div class="neutral--text lh-20">{{ maxSizeText }}</div>
  </div>
</template>

<script lang="ts" setup>
import WidgetIcon from '@widgets/shared/components/WidgetIcon.vue'
import translateService from '@widgets/shared/services/translate/translateService'
import { computed } from '@/composition/vue/compositionApi'
import { getFileSizeLabel } from '@/utils/file/getFileSizeLabel'

const { maxSize } = defineProps<{
  maxSize: number // in bytes
  text?: string
}>()

const maxSizeText = computed(() => {
  const sizeLabel = getFileSizeLabel(maxSize)
  return translateService.t('common.maximumFileSize', { size: sizeLabel })
})
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables.scss';

.file-drop-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background-color: $lift;
  border-radius: $border-radius-x;
  // https://kovart.github.io/dashed-border-generator/
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='6' ry='6' stroke='%23D0D5DDFF' stroke-width='2' stroke-dasharray='4%2c 10' stroke-dashoffset='17' stroke-linecap='square'/%3e%3c/svg%3e");
}
</style>
